export default __webpack_public_path__ + "static/media/45 min.0f5859e5.svg";